/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Material Dashboard 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Material Dashboard 2 React layouts
import Dashboard from "layouts/dashboard";
import Gare from "layouts/gare";
import Commessa from "layouts/commessa";
import Operaio from "layouts/anagrafica/operaio";
import Personale from "layouts/anagrafica/personale";
import Dipendenti from "layouts/anagrafica/dipendenti";
import Consulenti from "layouts/anagrafica/consulenti";
import Societa from "layouts/anagrafica/societa";
import Mezzi from "layouts/anagrafica/mezzi";
import GestioneManodopera from "layouts/gestione-operai";
import GestioneMezzi from "layouts/gestione-mezzi";
import GestioneAttivita from "layouts/commessa-note";
import Contabilita from "layouts/contabilita";
import SAL from "layouts/sal";
import Todo from "layouts/todo";


import Billing from "layouts/billing";
import RTL from "layouts/rtl";
import Notifications from "layouts/notifications";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";

import { ROLES} from "./constant"

// @mui icons
import Icon from "@mui/material/Icon";
const routes = [
    {
        name: "login",
        key: "login",
        icon: <Icon fontSize="small">dashboard</Icon>,
        route: "/authentication/sign-in",
        component: <SignIn />,
    },
    {
        type: "collapse",
        name: "Dashboard",
        key: "dashboard",
        icon: <Icon fontSize="small">dashboard</Icon>,
        route: "/dashboard",
        component: <Dashboard />,
    },
    {
        type: "collapse",
        name: "Gestione Gare",
        key: "gare",
        icon: <Icon fontSize="small">assignment_turned_in_icon</Icon>,
        route: "/gare",
        component: <Gare />,
        permission:[ROLES.admin, ROLES.appalti, ROLES.PM]
    },
    {
        type: "collapse",
        name: "Commesse",
        key: "commessa",
        icon: <Icon fontSize="small">inventory</Icon>,
        route: "/commessa",
        component: <Commessa />,
        permission: [ROLES.admin, ROLES.appalti, ROLES.segreteria, ROLES.ufficio_tecnico, ROLES.PM]
    },
    {
        type: "collapse",
        name: "Gestione Manodopera",
        key: "gestione-operai",
        icon: <Icon fontSize="small">engineering</Icon>,
        route: "/gestione-operai",
        component: <GestioneManodopera />,
        permission: [ROLES.admin, ROLES.ufficio_tecnico, ROLES.segreteria, ROLES.risorse_umane, ROLES.PM]
    },
    {
        type: "collapse",
        name: "Gestione Attività",
        key: "gestione-attivita",
        icon: <Icon fontSize="small">calendar_month</Icon>,
        route: "/gestione-attivita",
        component: <GestioneAttivita />,
        permission: [ROLES.admin, ROLES.ufficio_tecnico, ROLES.segreteria, ROLES.risorse_umane, ROLES.PM]
    },
    {
        type: "collapse",
        name: "Gestione Mezzi",
        key: "gestione-mezzi",
        icon: <Icon fontSize="small">local_shipping</Icon>,
        route: "/gestione-mezzi",
        component: <GestioneMezzi />,
        permission: [ROLES.admin, ROLES.ufficio_tecnico, ROLES.segreteria, ROLES.PM]
    },
    {
        type: "collapse",
        name: "Contabilità",
        key: "contabilita",
        icon: <Icon fontSize="small">balance</Icon>,
        route: "/contabilita",
        component: <Contabilita />,
        permission: [ROLES.admin, ROLES.ufficio_tecnico, ROLES.segreteria, ROLES.PM]
    },

    {
        type: "collapse",
        name: "SAL",
        key: "sal",
        icon: <Icon fontSize="small">manage_history</Icon>,
        route: "/sal",
        component: <SAL />,
        permission: [ROLES.admin, ROLES.ufficio_tecnico, ROLES.segreteria, ROLES.PM]
    },
    {
        type: "collapse",
        name: "Gestione assegnazioni",
        key: "todo",
        icon: <Icon fontSize="small">checklist</Icon>,
        route: "/todo",
        component: <Todo />,
        permission: [ROLES.admin, ROLES.ufficio_tecnico, ROLES.segreteria, ROLES.PM]
    },

    {
        type: "divider",
        key: "divider2",
        permission: [ROLES.admin, ROLES.risorse_umane, ROLES.PM]
    },
    {
        type: "title",
        title: "anagrafica",
        key: "title-anagrafica",
        permission: [ROLES.admin, ROLES.risorse_umane, ROLES.PM]
    },
    {
        type: "collapse",
        name: "Gestione Utenti",
        key: "utenti",
        icon: <Icon fontSize="small">personale</Icon>,
        permission: [ROLES.admin, ROLES.risorse_umane, ROLES.PM],
        collapse: [
            {
                name: "Società",
                key: "anagrafica/societa",
                icon: <Icon fontSize="small">business</Icon>,
                route: "/anagrafica/societa",
                component: <Societa />,
                permission: [ROLES.admin, ROLES.risorse_umane, ROLES.PM]
            },
            {
                name: "Account",
                key: "anagrafica/personale",
                icon: <Icon fontSize="small">person</Icon>,
                route: "/anagrafica/personale",
                component: <Personale />,
                permission: [ROLES.admin]
            },
            {
                type: "collapse",
                name: "Operaio",
                key: "anagrafica/operaio",
                icon: <Icon fontSize="small">engineering</Icon>,
                route: "/anagrafica/operaio",
                component: <Operaio />,
                permission: [ROLES.admin, ROLES.risorse_umane, ROLES.PM]
            },
            {
                type: "collapse",
                name: "Mezzi",
                key: "anagrafica/mezzi",
                icon: <Icon fontSize="small">local_shipping</Icon>,
                route: "/anagrafica/mezzi",
                component: <Mezzi />,
                permission: [ROLES.admin, ROLES.PM]
            },
            {
                type: "collapse",
                name: "Personale",
                key: "anagrafica/dipendenti",
                icon: <Icon fontSize="small">group</Icon>,
                route: "/anagrafica/dipendenti",
                component: <Dipendenti />,
                permission: [ROLES.admin, ROLES.PM, ROLES.risorse_umane]
            },
            {
                type: "collapse",
                name: "Consulenti",
                key: "anagrafica/consulenti",
                icon: <Icon fontSize="small">chat</Icon>,
                route: "/anagrafica/consulenti",
                component: <Consulenti />,
                permission: [ROLES.admin, ROLES.PM]
            },

        ],
    },
    {
        type: "divider",
        key:"divider3"
    },
   
  
];

export default routes;
